import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addProduct } from "../../store/thunk/addProduct";
import { response, addProductAction } from "../../store/actions/action";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

const AddProduct = (props) => {
    const dispatch = useDispatch();
    const [name, setName] = useState('');
    const [category, setCategory] = useState('');
    const [subCategory, setSubCategory] = useState('');
    const [description, setDescription] = useState('');
    const [price, setPrice] = useState('');
    const [mrp, setMrp] = useState('');
    const [stockQuantity, setStockQuantity] = useState('');
    const [batchNumber, setBatchNumber] = useState('');
    const [expiryDate, setExpiryDate] = useState('');
    const [requiresPrescription, setRequiresPrescription] = useState(false);
    const [freeShipping, setFreeShipping] = useState(true);
    const [cashOnDelivery, setCashOnDelivery] = useState(true);
    const [returns14Day, setReturns14Day] = useState(true);
    const [shippingCharge, setShippingCharge] = useState('');
    const [codCharge, setCodCharge] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [numberOfServings, setNumberOfServings] = useState('');
    const [servingSize, setServingSize] = useState('');
    const [proteinPerServing, setProteinPerServing] = useState('');
    const [vegetarianType, setVegetarianType] = useState('');

    const handleFileChange = (e) => setSelectedFile(e.target.files[0]);

    const validateDetails = () => {
        if (!name) return "Please enter name.";
        if (!category) return "Please enter category.";
        if (!subCategory) return "Please enter sub category.";
        if (!description || description.replace(/<(.|\n)*?>/g, '').trim() === '') return "Please enter description.";
        if (!price || isNaN(Number(price))) return "Please enter a valid price.";
        if (!selectedFile) return "Please choose an image.";
        return null;
    };

    const onSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        const errorMessage = validateDetails();
        if (errorMessage) {
            setError(errorMessage);
            setIsLoading(false);
            return;
        }
        setError(null);

        const productDetail = new FormData();
        productDetail.append('Name', name);
        productDetail.append('Category', category);
        productDetail.append('SubCategory', subCategory);
        productDetail.append('Description', description);
        productDetail.append('Price', Number(price));
        if (mrp) productDetail.append('MRP', Number(mrp));
        if (stockQuantity) productDetail.append('StockQuantity', Number(stockQuantity));
        if (batchNumber) productDetail.append('BatchNumber', batchNumber);
        if (expiryDate) productDetail.append('ExpiryDate', expiryDate);
        productDetail.append('RequiresPrescription', requiresPrescription);
        productDetail.append('FreeShipping', freeShipping);
        productDetail.append('CashOnDelivery', cashOnDelivery);
        productDetail.append('Returns14Day', returns14Day);
        if (!freeShipping && shippingCharge) productDetail.append('ShippingCharge', shippingCharge);
        if (!cashOnDelivery && codCharge) productDetail.append('CodCharge', codCharge);
        productDetail.append('Image', selectedFile);
        productDetail.append('UserId', props.userId);
        if (numberOfServings) productDetail.append('NumberOfServings', numberOfServings);
        if (servingSize) productDetail.append('ServingSize', servingSize);
        if (proteinPerServing) productDetail.append('ProteinPerServing', proteinPerServing);
        if (vegetarianType) productDetail.append('VegetarianType', vegetarianType);

        dispatch(addProduct(productDetail)).then((res) => {
            if (res.payload) {
                setName(''); setCategory(''); setSubCategory(''); setDescription('');
                setPrice(''); setMrp(''); setStockQuantity(''); setBatchNumber('');
                setExpiryDate(''); setRequiresPrescription(false); setSelectedFile(null);
                setNumberOfServings(''); setServingSize(''); setProteinPerServing(''); setVegetarianType('');
                setFreeShipping(true); setCashOnDelivery(true); setReturns14Day(true);
                setShippingCharge(''); setCodCharge('');
                setIsLoading(false);
                dispatch(addProductAction(res.payload));
                dispatch(response("Product added successfully."));
            } else {
                setIsLoading(false);
            }
        });
    };

    return (
        <div className="col-lg-8 col-md-8 col-12">
            <div className="ml-0 ml-md-4">
                <div className="d-none d-md-block">
                    <div className="row mb-md-5">
                        <div className="col">
                            <h5 className="mb-1 text-white">Add Product</h5>
                            <p className="mb-0 text-white small">Add a new medicine to the catalog.</p>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="card-body">
                        {error && <p style={{ color: "red" }}>{error}</p>}
                        <form className="row align-items-end" onSubmit={onSubmit}>
                            <div className="mb-3 col-12 col-md-6">
                                <label className="form-label" htmlFor="pName">Name <span className="text-danger">*</span></label>
                                <input type="text" id="pName" className="form-control" placeholder="Product Name" value={name} onChange={(e) => setName(e.target.value)} />
                            </div>
                            <div className="mb-3 col-12 col-md-6">
                                <label className="form-label" htmlFor="pCategory">Category <span className="text-danger">*</span></label>
                                <input type="text" id="pCategory" className="form-control" placeholder="e.g. Antibiotics" value={category} onChange={(e) => setCategory(e.target.value)} />
                            </div>
                            <div className="mb-3 col-12 col-md-6">
                                <label className="form-label" htmlFor="pSubCat">Sub Category <span className="text-danger">*</span></label>
                                <input type="text" id="pSubCat" className="form-control" placeholder="e.g. Tablet" value={subCategory} onChange={(e) => setSubCategory(e.target.value)} />
                            </div>
                                <div className="mb-3 col-12">
                                <label className="form-label" htmlFor="pDesc">Description <span className="text-danger">*</span></label>
                                <ReactQuill
                                    id="pDesc"
                                    theme="snow"
                                    value={description}
                                    onChange={setDescription}
                                    modules={{ toolbar: [
                                        [{ header: [2, 3, false] }],
                                        ['bold', 'italic', 'underline'],
                                        [{ list: 'ordered' }, { list: 'bullet' }],
                                        ['clean'],
                                    ]}}
                                    style={{ background: '#fff' }}
                                />
                            </div>
                            <div className="mb-3 col-12 col-md-6">
                                <label className="form-label" htmlFor="pPrice">Price (₹) <span className="text-danger">*</span></label>
                                <input type="number" id="pPrice" className="form-control" placeholder="Selling price" value={price} onChange={(e) => setPrice(e.target.value)} />
                            </div>
                            <div className="mb-3 col-12 col-md-6">
                                <label className="form-label" htmlFor="pMRP">MRP (₹)</label>
                                <input type="number" id="pMRP" className="form-control" placeholder="Original MRP" value={mrp} onChange={(e) => setMrp(e.target.value)} />
                            </div>
                            <div className="mb-3 col-12 col-md-6">
                                <label className="form-label" htmlFor="pStock">Stock Quantity</label>
                                <input type="number" id="pStock" className="form-control" placeholder="Units in stock" value={stockQuantity} onChange={(e) => setStockQuantity(e.target.value)} />
                            </div>
                            <div className="mb-3 col-12 col-md-6">
                                <label className="form-label" htmlFor="pBatch">Batch Number</label>
                                <input type="text" id="pBatch" className="form-control" placeholder="e.g. BT20240101" value={batchNumber} onChange={(e) => setBatchNumber(e.target.value)} />
                            </div>
                            <div className="mb-3 col-12 col-md-6">
                                <label className="form-label" htmlFor="pExpiry">Expiry Date</label>
                                <input type="date" id="pExpiry" className="form-control" value={expiryDate} onChange={(e) => setExpiryDate(e.target.value)} />
                            </div>
                            <div className="mb-3 col-12">
                                <hr className="my-1" />
                                <small className="text-muted">Nutritional Info (optional)</small>
                            </div>
                            <div className="mb-3 col-12 col-md-6">
                                <label className="form-label" htmlFor="pServings">Number of Servings</label>
                                <input type="text" id="pServings" className="form-control" placeholder="e.g. 30" value={numberOfServings} onChange={(e) => setNumberOfServings(e.target.value)} />
                            </div>
                            <div className="mb-3 col-12 col-md-6">
                                <label className="form-label" htmlFor="pServingSize">Serving Size</label>
                                <input type="text" id="pServingSize" className="form-control" placeholder="e.g. 5 g" value={servingSize} onChange={(e) => setServingSize(e.target.value)} />
                            </div>
                            <div className="mb-3 col-12 col-md-6">
                                <label className="form-label" htmlFor="pProtein">Protein per Serving</label>
                                <input type="text" id="pProtein" className="form-control" placeholder="e.g. 12 g" value={proteinPerServing} onChange={(e) => setProteinPerServing(e.target.value)} />
                            </div>
                            <div className="mb-3 col-12 col-md-6">
                                <label className="form-label" htmlFor="pVeg">Vegetarian / Non-Vegetarian</label>
                                <select id="pVeg" className="form-control" value={vegetarianType} onChange={(e) => setVegetarianType(e.target.value)}>
                                    <option value="">-- Select --</option>
                                    <option value="Vegetarian">Vegetarian</option>
                                    <option value="Non-Vegetarian">Non-Vegetarian</option>
                                </select>
                            </div>
                            <div className="mb-3 col-12">
                                <hr className="my-1" />
                            </div>
                            <div className="mb-3 col-12 col-md-6">
                                <label className="form-label" htmlFor="pImage">Product Image <span className="text-danger">*</span></label>
                                <input type="file" id="pImage" className="form-control" accept="image/*" onChange={handleFileChange} />
                                {selectedFile && (
                                    <div className="mt-2">
                                        <img
                                            src={URL.createObjectURL(selectedFile)}
                                            alt="Preview"
                                            style={{ width: 120, height: 120, objectFit: 'cover', borderRadius: 6, border: '2px solid #0d6efd' }}
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="mb-3 col-12">
                                <hr className="my-1" />
                                <small className="text-muted">Product Options</small>
                            </div>
                            <div className="mb-3 col-12">
                                <div className="form-check mb-2">
                                    <input className="form-check-input" type="checkbox" id="pRx" checked={requiresPrescription} onChange={(e) => setRequiresPrescription(e.target.checked)} />
                                    <label className="form-check-label" htmlFor="pRx">Requires Prescription (Rx)</label>
                                </div>
                                <div className="form-check mb-1">
                                    <input className="form-check-input" type="checkbox" id="pFreeShip" checked={freeShipping} onChange={(e) => { setFreeShipping(e.target.checked); if (e.target.checked) setShippingCharge(''); }} />
                                    <label className="form-check-label" htmlFor="pFreeShip">Free Shipping</label>
                                </div>
                                {!freeShipping && (
                                    <div className="mb-2 ms-4" style={{maxWidth:220}}>
                                        <label className="form-label small mb-1">Shipping Charge (₹)</label>
                                        <input type="number" className="form-control form-control-sm" placeholder="e.g. 40" min="0" value={shippingCharge} onChange={(e) => setShippingCharge(e.target.value)} />
                                    </div>
                                )}
                                <div className="form-check mb-1">
                                    <input className="form-check-input" type="checkbox" id="pCOD" checked={cashOnDelivery} onChange={(e) => { setCashOnDelivery(e.target.checked); if (e.target.checked) setCodCharge(''); }} />
                                    <label className="form-check-label" htmlFor="pCOD">Cash on Delivery</label>
                                </div>
                                {!cashOnDelivery && (
                                    <div className="mb-2 ms-4" style={{maxWidth:220}}>
                                        <label className="form-label small mb-1">COD Charge (₹)</label>
                                        <input type="number" className="form-control form-control-sm" placeholder="e.g. 20" min="0" value={codCharge} onChange={(e) => setCodCharge(e.target.value)} />
                                    </div>
                                )}
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" id="pReturns" checked={returns14Day} onChange={(e) => setReturns14Day(e.target.checked)} />
                                    <label className="form-check-label" htmlFor="pReturns">14-Day Returns</label>
                                </div>
                            </div>
                            <div className="col-12 mb-3 text-lg-right">
                                <button className="btn btn-primary" type="submit" disabled={isLoading}>
                                    <span className={`${isLoading ? 'spinner-border' : ''} spinner-border-sm`} role="status" aria-hidden="true"></span>
                                    {isLoading ? ' Adding...' : ' Add Product'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddProduct;
